"use client";
import {
  GridRow,
  GridColumn,
  Grid,
  Button,
  Form,
  TextArea,
} from "semantic-ui-react"; // adjust if different in your project
import ModalWrapper from "./ModalWrapper";

export default function EditCaptionModal({
  editcaptionmodal,
  closeeditcaptionmodal,
  customStyles,
  EditcaptionFormSubmit,
  selectedcaption,
}) {
  return (
    <ModalWrapper
      isOpen={editcaptionmodal}
      onRequestClose={closeeditcaptionmodal}
      style={customStyles}
      contentLabel="Edit Caption Modal"
    >
      {/* Close Button */}
      <div className="slider_modal_btn">
        <span
          onClick={closeeditcaptionmodal}
          data-primary={true}
          style={{ marginTop: "10px" }}
        >
          X
        </span>
      </div>

      {/* Form */}
      <Form onSubmit={EditcaptionFormSubmit} style={{ width: "97%" }}>
        <Grid className="modal_grid">
          <GridRow>
            <GridColumn mobile={16} tablet={16} computer={16}>
              <TextArea
                placeholder="Edit caption"
                defaultValue={selectedcaption}
                name="caption_summary"
                style={{
                  width: "100%",
                  marginTop: "25px",
                }}
              />
            </GridColumn>
          </GridRow>

          <div className="caption_btn">
            <Button type="submit" primary style={{ marginTop: "10px" }}>
              Save
            </Button>
          </div>
        </Grid>
      </Form>
    </ModalWrapper>
  );
}
